import React, {useEffect, useContext, useState} from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import { useMap } from 'react-leaflet';
import { Context } from '../store/reducer';
import { legendArrays } from './DoboxLayerGroup/config';
import Popup95_1 from "./Spot/menu/popup95_1";

const VectorGrid95_1 = ({id, url, layerName, color, opacity, borderColor}) => {
    const map = useMap()
    const { state } = useContext(Context);

    const [showPopup, setShowPopup ]= useState(false);
    const [polygonProperties, setPolygonProperties ]= useState([]);
    const [lat, setLat] = useState();
    const [lng, setLng] = useState();

    const getStyles = ($id, properties) => {

        let color;
        let borderColor;
        let fillColor;
        let useBorder = false;

        let legendSettings = legendArrays[id];
        
        let value;
        
        value = properties["01_RA"];    
        
        // テスト用データ
        // const testDataList = [
        //     0,50,51,
        //     54,55,56,
        //     59,60,61, 
        //     64,65,66, 
        //     69,70,71, 
        //     74,75,76, 
        //     79,80,81, 
        //     84,85,86, 
        //     89,90,91, 
        //     94,95,96, 
        //     99,100,101,
        // ];
        //
        // value = testDataList[Math.floor(Math.random() * testDataList.length)];
        

        for(let i=0; i < legendSettings.length; i++) {
            
            // 判定する値
            const targetValue = legendSettings[i].maxValue;
            
            if (color) {
                continue;
            }
            
            // 表示可能の限界値より小さい場合の判定
            if (legendSettings[i].type === "hidden") {
                // 未満としている。
                if (value < targetValue) {
                    color = legendSettings[i].color;
                }
                continue;
            }
            
            // 50の場合は一致判定とする。(汎用的な判定ロジックと両立するために個別判定判定)
            if (targetValue == 50 && value == 50) {
                color = legendSettings[i].color;
                continue;
            }
            
            // 判定には等号をつける
            if (value < targetValue) {
                color = legendSettings[i].color;
            }
        }
        
        if (useBorder) {
            borderColor = color;
        }
        
        fillColor = color ? color : "transparent";
        
        return {
            value: value, // debug用にセットしている。clickイベントで使用する。
            opacity: state.opacity,
            fill: true,
            color: borderColor,
            fillColor: fillColor,
            dashArray: 0,
            fillOpacity: state.opacity
        }
    } 
    
    useEffect(() => {
        const vectorGrid = L.vectorGrid.protobuf(url, {
            interactive: true,
            vectorTileLayerStyles: {
                [layerName]: function(properties){
                    return getStyles(id, properties)
                }
            },
        })

        vectorGrid.on('click', function(e) {

            // console.log("click地点の値: "+e.layer.options.value);
            
            setLat(e.latlng.lat)
            setLng(e.latlng.lng)
            setPolygonProperties(e.layer.properties)
            setShowPopup(true)
        });
        
        vectorGrid.addTo(map)

        return () => vectorGrid.remove()
    }, [state.opacity])
    
    return (showPopup ? <Popup95_1
      id={id}
      latitude={lat}
      longitude={lng}
      polygonProperties={polygonProperties}
      closePopup={() => {
        setShowPopup(false)
      }}
    /> : null)
}

export default VectorGrid95_1
